import { useTranslation } from "react-i18next"
import {
  Bar,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
} from "recharts"

import {
  ChartContainer,
  ChartTooltip,
} from "@/components/ui/chart"
import { DashboardInfoTypeEnum } from "@/enums"
import { useDashboard } from "@/hooks"
type DashboardInstallmentAmountRecurringChartProps =
  SearchParamsType
export const DashboardInstallmentAmountRecurringChart: React.FC<
  DashboardInstallmentAmountRecurringChartProps
> = ({ searchParams }) => {
  const { t } = useTranslation()
  const { data: installmentAmountRecurring } = useDashboard(
    {
      ...searchParams,
      dashboardType:
        DashboardInfoTypeEnum.INSTALLMENT_AMOUNT_RECURRING,
    }
  )
  const chartData =
    installmentAmountRecurring?.indicator?.map(
      (indicator) => ({
        parcelas: indicator.key,
        quantidade: +indicator.value,
      })
    )

  if (!chartData || chartData.length === 0) {
    return (
      <div className="flex min-h-[200px] items-center justify-center text-sm text-muted-foreground">
        {t("pages.dashboard.noDataAvailable")}
      </div>
    )
  }

  return (
    <ChartContainer
      config={{
        parcelas: {
          label: "Parcelas",
        },
        quantidade: {
          label: "Quantidade",
        },
      }}
      className="-ml-6 max-h-[200px] w-full md:-ml-3"
    >
      <BarChart accessibilityLayer data={chartData}>
        <CartesianGrid vertical={false} />
        <XAxis
          dataKey="parcelas"
          tickLine={false}
          tickMargin={10}
          axisLine={false}
        />
        <YAxis
          dataKey="quantidade"
          tickLine={false}
          axisLine={false}
          tickMargin={8}
          tickFormatter={(value) =>
            value.toLocaleString("pt-BR")
          }
        />
        <ChartTooltip
          cursor={false}
          content={({ label, payload }) => {
            const numberLabel = Number(label)
            const formattedLabel = `${numberLabel} ${numberLabel === 1 ? "parcela" : "parcelas"}`
            return (
              <div className="flex w-48 flex-col gap-2 rounded-lg border bg-background px-2 py-1.5 text-foreground shadow-lg">
                <div className="flex items-center gap-2 before:size-3 before:rounded-sm before:bg-primary">
                  {formattedLabel}
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-muted-foreground">
                    Quantidade de Pedidos
                  </span>
                  <span>
                    {payload &&
                      payload[0]?.payload.quantidade}
                  </span>
                </div>
              </div>
            )
          }}
        />
        <Bar
          dataKey="quantidade"
          fill="hsl(var(--primary))"
          radius={8}
        />
      </BarChart>
    </ChartContainer>
  )
}
